<template>
    <div class="user-price">
        <!-- 会员价格 -->
         <div class="user-title clearfix">
            <div class="fl">充值会员</div>
        </div>
        <div class="content font-s12">
            <el-row >
                <el-col :span="3" class="c66">充值会员</el-col>
                <el-col :span="21" class="c06">{{priceInfo.txt}}</el-col>
            </el-row>
            <el-row  class="pd-t-25">
                <el-button type="success" plain @click="nextStep" v-if="priceInfo.is_vip==false">下一步</el-button>
            </el-row>
        </div>
    </div>
</template>

<script>
import { PayTags } from "../../api/api";

export default {
 data(){
     return{
        //from从哪个页面转入 
        item:this.$route.query.item==undefined?'':JSON.parse(this.$route.query.item),
        priceInfo:'',
     }
 },
 created(){
        this.$axios.post(PayTags, {}).then(
          res => {
            if (res.data.code == 1) {
             this.priceInfo=res.data.data;
            } else {
                this.$message.error(res.data.msg);
            }
          },
          err => {
            this.$message.error(err.data.msg);
          }
        );
 },
 methods:{
     nextStep(){
         this.$router.push({name:'userPay',query:{item:JSON.stringify(this.item)}});
     },
 }
}
</script>

<style lang="scss">
.user-price{
 .content{
     padding: 30px;
     
 }
}
</style>
